import { SingletonSharedData } from '../Singleton/SingletonSharedData'

export const STRATEGY_CALL_FLOW = {
    "onCallRecieved": function (json) {
        if (typeof onCallRecieved === 'function') {
            let callInformation = {};
            callInformation.Action = json.data.action;
            callInformation.Agent = { ID: SingletonSharedData.getUserId(), userName: SingletonSharedData.getUserName() };
            callInformation.AllowACDCallBack = true;
            callInformation.CalKey = json.data.CalKey;
            callInformation.CallId = Math.abs(json.data.CallId);
            callInformation.CallOutId = json.data.CallOutId;
            callInformation.CallType = json.data.CallType;
            callInformation.DataContact = json.data.DataContact ? json.data.DataContact : json.data.ContactData;
            callInformation.DataKeyValue = json.data.DataKeyValue;
            callInformation.Description = json.data.Description;
            callInformation.DNIS = json.data.DNIS ? json.data.DNIS : '';
            callInformation.EngineId = json.data.EngineId;
            callInformation.Frame = json.data.Frame;
            callInformation.holdTime = json.data.holdCall ? json.data.holdCall : '';
            callInformation.HoldTime = json.data.HoldTime ? json.data.HoldTime : '';
            callInformation.Id = json.data.Id;
            callInformation.IsACDTransfer = json.data.IsACDTransfer;
            callInformation.IsQueueCall = json.data.IsQueueCall;
            callInformation.Phone = json.data.Phone;
            callInformation.Port = json.data.Port ? json.data.Port : '';
            callInformation.SecondPhone = 0;
            callInformation.WaitingTime = json.data.WaitingTime;
            callInformation.WrapUpTime = json.data.WrapUpTime ? json.data.WrapUpTime : 0;
            SingletonSharedData.setDataCall(callInformation);
            onCallRecieved(callInformation);
        }
    },
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyCallFlow.js